'use client';
import React from 'react';
import { X, Bell, MessageCircle, Tag, CreditCard, CheckCircle, AlertCircle } from 'lucide-react';
import { useNotifications } from '@/contexts/NotificationContext';
import { useRouter } from 'next/navigation';

function getToastIcon(type: string) {
  switch (type) {
    case 'message': return <MessageCircle size={16} className="text-[#3B82F6]" />;
    case 'offer': return <Tag size={16} className="text-[#F59E0B]" />;
    case 'payment': return <CreditCard size={16} className="text-[#10B981]" />;
    case 'approval': return <CheckCircle size={16} className="text-[#10B981]" />;
    case 'rejection': return <AlertCircle size={16} className="text-[#EF4444]" />;
    default: return <Bell size={16} className="text-[#D93025]" />;
  }
}

function getToastBorder(type: string) {
  switch (type) {
    case 'message': return 'border-l-[#3B82F6]';
    case 'offer': return 'border-l-[#F59E0B]';
    case 'payment': return 'border-l-[#10B981]';
    case 'approval': return 'border-l-[#10B981]';
    case 'rejection': return 'border-l-[#EF4444]';
    default: return 'border-l-[#D93025]';
  }
}

export default function ToastContainer() {
  const { toasts, dismissToast } = useNotifications();
  const router = useRouter();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-2 pointer-events-none" style={{ maxWidth: '360px' }}>
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`pointer-events-auto bg-white border border-[#E2E2E7] border-l-4 ${getToastBorder(toast.type)} rounded-[14px] shadow-modal p-4 flex items-start gap-3 animate-slide-up`}
        >
          <div className="w-8 h-8 rounded-full bg-[#F5F5F7] flex items-center justify-center flex-shrink-0">
            {getToastIcon(toast.type)}
          </div>
          <div
            className="flex-1 min-w-0 cursor-pointer"
            onClick={() => {
              if (toast.action_url) router.push(toast.action_url);
              dismissToast(toast.id);
            }}
          >
            <p className="font-700 text-[#1D1D1F] text-[13px] leading-snug">{toast.title}</p>
            {toast.body && <p className="text-[12px] text-[#6E6E73] mt-0.5 line-clamp-2">{toast.body}</p>}
          </div>
          <button
            onClick={() => dismissToast(toast.id)}
            className="w-6 h-6 rounded-full flex items-center justify-center text-[#A1A1A6] hover:bg-[#F5F5F7] transition-colors flex-shrink-0"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  );
}
